/**
 * Extrai filename de Content-Disposition; fallback para o nome solicitado.
 */
export function getFilenameFromHeaders(headers: any, fallback: string): string {
  try {
    const cd: string | undefined =
      headers?.["content-disposition"] || headers?.get?.("content-disposition");
    if (!cd) return fallback;
    const match = /filename\*?=(?:UTF-8''|")?([^"]+)/i.exec(cd);
    if (!match?.[1]) return fallback;
    return decodeURIComponent(match[1].replace(/"/g, ""));
  } catch {
    return fallback;
  }
}

/**
 * Salva o Blob localmente, criando um link temporário.
 */
export function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
